export const Limite = {
  PDF: 60000,
  XML: 60000,
  TXT: 60000,
  XLSX: 60000,
  CSV: 60000,
  JPG: 1500,
};
